import { Util } from "@xt/xtbase";
import generateFlatMethods from "./method";

const { getOrigin } = Util;
const baseUrl = getOrigin("www") + "/sapi/v4/balance";

const {
  get,
  put,
  post,
  del,
} = generateFlatMethods(baseUrl);

const querystring = (params, prefix = true) => 
  Object.entries(params)
    .reduce((result, [key, value]) => {
      if (result) {
        result += '&';
      } else if (prefix) {
        result += '?';
      }

      return result += `${key}=${value}`;
    },
    '',
  );

const factory = (method, url) => (
  data,
  {
    urlAppend = false,
    ...config
  } = {},
) => {
  let params = data;
  let realUrl = url;
  if (urlAppend) {
    realUrl = `${url}${querystring(data)}`;
    params = null;
  }
  
  return method(realUrl, params, config);
};

// IEO列表
export const getIeoList = factory(
  get,
  '/public/finance/product/ieo',
);

// 获取IEO详情
export const getIeoDetail = factory(
  get,
  '/public/finance/product/ieo/detail',
);

// IEO Order
export const getIeoOrderRecords = factory(
  get,
  '/finance/ieo/order',
);

//
export const getBalances = factory(
  get,
  '/balances',
);

// export const postOrder = factory(
//   post,
//   '/finance/order',
// );

export const getAlreadyBuy = factory(
  get,
  '/finance/product-position',
);